
export const useFirstPeriod = ()=>{
    return WP_OctaviusRocks_Admin?.taxonomy_term_views?.first_period || false;
}

export const useTaxonomies = ()=>{
    return WP_OctaviusRocks_Admin?.taxonomy_term_views?.taxonomies || [];
}
